import { createAsyncThunk } from "@reduxjs/toolkit";
import { ANNOTATIONS, IMAGES_MODULE, INFO, INSPECTION, INSPECTIONS, SPANS, SURVEYS } from "~/components/cesiumComponents/constants";
import { dataServer } from "~/constants";
import { selectImageAnnotations, setFeaturedAnnotationsIds, setSelectedAnnotationsIds } from "~/slices/annotationsManagerSlice";
import { setInspectionPoint } from "~/slices/cesiumSlice";
import { setComponent } from "~/slices/componentAllocatorSlice";
import { setImages, setSelectedImage } from "~/slices/imagesModuleSlice";
import type { Annotation } from "~/types/annotations";
import type { CloudImage } from "~/types/CloudImage";
import { detectionStringToObj } from "~/utils/annotationsUtils";
import { getElementsWithAnnotations } from "./getters";
import { selectElements } from "~/slices/assetSlice";
import type { BridgeElement } from "~/types/bridge";
import type { RootState } from "~/store";
import { setSelectedObjectIds } from "~/slices/entitiesControllerSlice";
import { SURVEY } from "~/slices/constants";

export const createAnnotationThunk = createAsyncThunk(
  "createAnnotationThunk",
  async ({ annotation }: { annotation: Partial<Annotation> }, { rejectWithValue, dispatch, getState }) => {

    const state = getState() as RootState;
    const image = state.imagesModule.selectedImage;
    const surveyId = state.displayedSurvey.surveyId;
    const bid = state.asset.asset?.bid;
    const selectedObjectIds = state.entitiesController.selectedObjectIds
    const canvasData = JSON.parse(
      localStorage.getItem('originalDimentions') || '{}',
    );
    const original_image_data = {
      width: canvasData.imageWidth,
      height: canvasData.imageHeight,
    };
    let newAnnotation = { ...annotation };
    newAnnotation.original_image_data = JSON.stringify(original_image_data);
    newAnnotation.image_name = image?.fullImageName.split(
      '/',
    )[
      image?.fullImageName.split(
        '/',
      ).length - 1
    ],
    newAnnotation.image_path = image?.fullImageName,
      // annotation.image = image,
    newAnnotation.survey_id = surveyId as number;
    newAnnotation.bid = bid as number;
    newAnnotation.entity = selectedObjectIds.length > 0 ? selectedObjectIds[0] : '';
    newAnnotation.user = `${state.user.currentUser?.first_name} ${state.user.currentUser?.last_name}`
    const url = `${dataServer}annotations`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ annotation: newAnnotation }),
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const responseData = await response.json();
      console.log("createAnnotationThunk response", responseData);
      const finalAnnotation: Annotation = {
        ...responseData.annotation.data,
        measurements: responseData.measurements,
      }
      return finalAnnotation;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }

// if (isRtl && annotationData.annotation_type !== GENERAL) {
//             annotationsByDefectCode = props.imageAnnotations.filter(
//               ann =>
//                 ann.entity == currentSelectedObjectIds.current[0] &&
//                 ann.defect_code == annotationData.defect_code,
//             );
//             annotationsByDefectCode.push(annotationData);

//             updatedElementsData = handleNewAnnotationDefectRatingForIsraelOrgs(
//               currentSelectedObjectIds.current[0],
//               annotationData,
//               annotationsByDefectCode,
//               updatedElementsData,
//             );
//             props.onUpdateSurveyField(
//               'elements_data',
//               updatedElementsData,
//               props.survey.id,
//             );
//           }

  });
export const updateAnnotationThunk = createAsyncThunk(
  "updateAnnotationThunk",
  async ({ annotation }: { annotation: Partial<Annotation> }, { rejectWithValue, dispatch, getState }) => {
    console.log("updateAnnotationThunk params", { annotation });
    const state = getState() as RootState;
    const oldAnnotation = state.annotationsManager.imageAnnotations.find(ann => ann.id === annotation.id);
    if (!oldAnnotation) {
      return rejectWithValue("Annotation not found");
    }
    const measurementsToDelete = oldAnnotation.measurements.filter(m => m.id && !annotation.measurements?.some(newM => newM.id === m.id));
    const selectedObjectIds = state.entitiesController.selectedObjectIds

    let newAnnotation = { ...annotation };

    newAnnotation.entity = selectedObjectIds.length > 0 ? selectedObjectIds[0] : '';
    newAnnotation.user = `${state.user.currentUser?.first_name} ${state.user.currentUser?.last_name}`
    newAnnotation.measurements = annotation.measurements?.filter(m => !m.id);
    console.log("isNewAnnotation", newAnnotation);
    const url = `${dataServer}annotations`;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ annotation: newAnnotation, measurementsToDelete }),
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const responseData = await response.json();
      console.log("updateAnnotationThunk response", responseData);
      const finalAnnotation: Annotation = {
        ...responseData.annotation.data,
        measurements: [...(annotation.measurements?.filter(m => m.id) || []), ...responseData.measurements || []],
      }
      return finalAnnotation;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }

// if (isRtl && annotationData.annotation_type !== GENERAL) {
//             annotationsByDefectCode = props.imageAnnotations.filter(
//               ann =>
//                 ann.entity == currentSelectedObjectIds.current[0] &&
//                 ann.defect_code == annotationData.defect_code,
//             );
//             annotationsByDefectCode.push(annotationData);

//             updatedElementsData = handleNewAnnotationDefectRatingForIsraelOrgs(
//               currentSelectedObjectIds.current[0],
//               annotationData,
//               annotationsByDefectCode,
//               updatedElementsData,
//             );
//             props.onUpdateSurveyField(
//               'elements_data',
//               updatedElementsData,
//               props.survey.id,
//             );
//           }

  });
export const getAiDetectionsThunk = createAsyncThunk(
  "annotationsManager/getAiDetections",
  async (
    params: { surveyId: number; orgId: number },
    // thunkAPI: { dispatch: Function; getState: Function }
  ) => {
    const { surveyId, orgId } = params;
    // console.log({ surveyId, orgId });
    if (!surveyId || !orgId) {
      throw new Error("Survey or organization not found in state");
    }
    const response = await fetch(`${dataServer}surveys/${surveyId}/${orgId}/aiDetections`);
    // console.log("getAiDetectionsThunk response", response);
    if (!response.ok) {
      throw new Error("Failed to fetch AI detections");
    }
    const data = await response.json();
    // console.log({data})
    const aiDetections = data
      .filter((str: string) => str && str.length > 1)
      .map((detection: string) => detectionStringToObj(detection));

    console.log("AI detections data", aiDetections);
    return aiDetections;

  })


export const setSelectedAnnotationsIdsThunk = createAsyncThunk(
  "annotationsManager/setSelectedAnnotationsIds",
  async (ids: Annotation['id'][], { dispatch, getState }) => {
    const state = getState() as any;
    if (ids.length !== 0) {
      dispatch(setInspectionPoint(null));
      dispatch(setComponent([
        {
        component: "bottomView",
        value: ANNOTATIONS
      },
      {
        component: "rightView",
        value: IMAGES_MODULE
      }
    ]))
    }
    const surveyFiles = state.displayedSurvey.surveyFiles;
    const annotations = state.annotationsManager.imageAnnotations;
    const selectedAnns = ids.map((id: string | number) =>
      annotations.find((ann: Annotation) => ann.id === id)
    );
    console.log("setSelectedAnnotationsIdsThunk selectedAnns", selectedAnns);
    const objectIds = selectedAnns.map((annotation: Annotation) => annotation.entity);

    const images = selectedAnns
      .filter((ann: Annotation) => ann.image_path)
      .map((ann: Annotation) =>
        surveyFiles.images.find(
          (img: CloudImage) => img.fullImageName.includes(ann.image_path)
        )
      );
    // console.log("setSelectedAnnotationsIds images", images);
    // dispatch(setSelectedObjectIds(objectIds));
    dispatch(setSelectedAnnotationsIds(ids));

    // console.log("setSelectedAnnotationsIdsThunk images", images);
    dispatch(setImages(images as CloudImage[]));
    dispatch(setSelectedImage(images[0] as CloudImage))
  }
);
export const onSelectAnnotationIdsThunk = createAsyncThunk(
  "annotationsManager/onSelectAnnotationId",
  async (ids: Annotation['id'][], { dispatch, getState }) => {
    
    try {
      const state = getState() as any;
      const elements = selectElements(state);
      const allAnnotations: Annotation[] = selectImageAnnotations(state); // Use the selector
      const annotations = allAnnotations.filter(ann => ids.includes(ann.id) && ann.entity);
      const elementsWithAnnotations = getElementsWithAnnotations(state);

      if (!annotations || annotations.length === 0) {
        console.error(`Annotations with ids ${ids} not found`);
        return;
      }
      console.log("onSelectAnnotationIdThunk", { annotations, elementsWithAnnotations });
      // Find the element that contains this annotation
      const objectIds = annotations.map(ann => ann.entity);
      if (objectIds.length === 0) {
        console.error(`No object_ids found for annotations with ids ${ids}`);
        return;
      }
      const selectedElements = elementsWithAnnotations.filter(
        (el: any) => objectIds.includes(el.object_id),
      );
      
      if (!selectedElements || selectedElements.length === 0) {
        console.error(`Elements with object_ids ${objectIds} not found`);
        return;
      }
      const annotationsbyElements = selectedElements.map((el: any) => el.children).flat();
      const annIds = annotationsbyElements.map((ann: any) => ann.id);
      console.log("onSelectAnnotationIdThunk selectedElements", selectedElements, { annIds });
      // Dispatch the actions
      await dispatch(setSelectedAnnotationsIdsThunk(ids));
      dispatch(setFeaturedAnnotationsIds(annIds));
      dispatch(setSelectedObjectIds(objectIds.filter((id: any): id is string => id !== null)));
      dispatch(setComponent([
        { component: 'bottomView', value: ANNOTATIONS },
        { component: 'rightView', value: IMAGES_MODULE },
        { component: "leftView", value: SURVEYS },
        { component: "surveysTab", value: INSPECTIONS },
        { component: "inspectionsTab", value: INSPECTION },
      ]));
      
    } catch (error) {
      console.error('Error in onSelectAnnotationIdThunk:', error);
      throw error;
    }
  }
);
export const onSelectElementIdThunk = createAsyncThunk(
  "annotationsManager/onSelectElementId",
  async (elementName: BridgeElement['name'], { dispatch, getState }) => {
    
    try {
      const state = getState() as any;
      const elementsWithAnnotations = getElementsWithAnnotations(state);

      if (!elementsWithAnnotations) {
        console.error(`Elements with annotations not found`);
        return;
      }
      
      // Find the element that contains this annotation
      const element = elementsWithAnnotations.find(
        (el: any) => el.object_id === elementName,
      );
      
      if (!element) {
        console.error(`Element with object_id ${elementName} not found`);
        return;
      }      

      dispatch(setFeaturedAnnotationsIds(element.children.map((child: any) => child.id)));
      dispatch(setComponent([
        { component: 'bottomView', value: ANNOTATIONS },
        { component: 'rightView', value: IMAGES_MODULE },
      ]));
      
    } catch (error) {
      console.error('Error in onSelectAnnotationIdThunk:', error);
      throw error;
    }
  }
);